// @flow
import { useContext } from 'react';
import { Device } from '@ta/lithium.context';

const onTouchEnd = (evt: SyntheticTouchEvent<*>) => {
  // Simulate a click immediately, and prevent the click that would otherwise happen after a short
  // delay
  evt.preventDefault();
  evt.currentTarget.click();
};

/**
 * Returns an event handler that simulates clicking on an element immediately after tapping it.
 * This can be used on iOS Safari, where this is normally a delay after tapping an input.
 *
 * In other browsers, the CSS "touch-action: manipulation" property removes this delay.
 */
const useFastManipulation = () => {
  const { os } = useContext(Device);

  // Only needed on iOS
  if (os.family === 'IOS') {
    return { onTouchEnd };
  }

  // Other browsers use `touch-action: manipulation` to do the same thing
  return {};
};

export default useFastManipulation;
